"use client";
import {
  snippet_default
} from "./chunk-2NDBIRLR.mjs";
import {
  useSnippet
} from "./chunk-ITBM7SHQ.mjs";
export {
  snippet_default as Snippet,
  useSnippet
};
